module.exports = __webpack_public_path__ + "img/sld_central_box_green_ta1_ba1.92d0a348.svg";